import { useContext } from "react"
import AuthContext from "../contexts/AuthContext"

export const useAuthContext = () => {
    return useContext(AuthContext)
}